import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
// import { getbase64 } from '@/utils/base64Converter';
import { useFormik } from 'formik';
import {
  EditUserAddress,
  EditUserDetails,
  EditUserPassword,
} from '../../redux/user/user_profile/user_profile_service_syn';
import { InfinitySpin } from 'react-loader-spinner';

const DetailsSchema = Yup.object({
  phone_number: Yup.string().required(),
  about: Yup.string().required(),
});

const AddressSchema = Yup.object({
  city: Yup.string().required(),
  country: Yup.string().required(),
  address: Yup.string().required(),
});

const passwordSchema = Yup.object({
  oldPassword: Yup.string().required(),
  password: Yup.string().min(6).required(),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Confirm Password is required'),
});

const Profile = () => {
  const dispatch = useDispatch();

  const { profile, editLoader } = useSelector((state) => state.user_profile);

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();

    if (editLoader) return;

    const payload = {
      ...value,
    };

    await dispatch(EditUserDetails({ ...payload }));

    resetForm();
  };

  const handleSubmitedAddress = async (value, { resetForm }) => {
    // e.preventDefault();

    if (editLoader) return;

    const payload = {
      ...value,
    };

    await dispatch(EditUserAddress({ ...payload }));

    resetForm();
  };

  const handleSubmitedPassword = async (value, { resetForm }) => {
    // e.preventDefault();

    if (editLoader) return;

    const payload = {
      ...value,
    };

    await dispatch(EditUserPassword({ ...payload }));

    resetForm();
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      phone_number: '',
      about: '',
    },
    validationSchema: DetailsSchema,
    onSubmit: handleSubmited,
  });

  const {
    values: valuesAddress,
    handleBlur: handleBlurAddress,
    handleChange: handleChangeAddress,
    handleSubmit: handleSubmitAddress,
    errors: errorsAddress,
    setFieldValue: setFieldValueAddress,
  } = useFormik({
    initialValues: {
      city: '',
      country: '',
      address: '',
    },
    validationSchema: AddressSchema,
    onSubmit: handleSubmitedAddress,
  });

  const {
    values: valuesPassword,
    handleBlur: handleBlurPassword,
    handleChange: handleChangePassword,
    handleSubmit: handleSubmitPassword,
    errors: errorsPassword,
    setFieldValue: setFieldValuePassword,
  } = useFormik({
    initialValues: {
      password: '',
      confirm_password: '',
      oldPassword: '',
    },
    validationSchema: passwordSchema,
    onSubmit: handleSubmitedPassword,
  });

  return (
    <>
      <div class="wrapper">
        <div class="page-content">
          <div class="container-xxl">
            <div class="row mt-6">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title d-flex align-items-center gap-1">
                      <iconify-icon
                        icon="solar:settings-bold-duotone"
                        class="text-primary fs-20"
                      ></iconify-icon>
                      Personal Profile
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <form>
                          <div class="mb-3">
                            <label for="meta-name" class="form-label">
                              Name
                            </label>
                            <input
                              type="text"
                              id="name"
                              class="form-control"
                              placeholder="Name"
                              disabled
                              value={profile?.name}
                            />
                          </div>
                        </form>
                      </div>
                      <div class="col-lg-6">
                        <form>
                          <div class="mb-3">
                            <label for="meta-tag" class="form-label">
                              Email
                            </label>
                            <input
                              type="text"
                              id="meta-tag"
                              class="form-control"
                              name="email"
                              placeholder="Email"
                              disabled
                              value={profile?.email}
                            />
                          </div>
                        </form>
                      </div>
                      <div class="col-lg-6">
                        <form>
                          <div class="mb-3">
                            <label for="meta-tag" class="form-label">
                              Phone Number
                            </label>
                            <input
                              type="text"
                              id="meta-tag"
                              class={`form-control ${
                                errors.phone_number ? 'is-invalid' : ''
                              }`}
                              name="phone_number"
                              placeholder="Enter Phone Number"
                              value={
                                profile?.phone_number ||
                                values?.phone_number ||
                                ''
                              }
                              onChange={handleChange}
                            />
                          </div>
                        </form>
                      </div>

                      <div class="col-lg-12">
                        <div class="">
                          <label for="description" class="form-label">
                            About
                          </label>
                          <textarea
                            class={`form-control bg-light-subtle ${
                              errors.about ? 'is-invalid' : ''
                            }`}
                            id="description"
                            rows="4"
                            placeholder="Enter About YourSelf"
                            name="about"
                            value={profile?.about || values?.about || ''}
                            onChange={handleChange}
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div class="text-end mt-4">
                      <a class="btn btn-success" onClick={handleSubmit}>
                        {editLoader ? (
                          <div class="form-group col-sm-9">
                            <InfinitySpin width="100" color="#FE6B30" />
                          </div>
                        ) : (
                          <>Update User Details</>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title d-flex align-items-center gap-1">
                      <iconify-icon
                        icon="solar:shop-2-bold-duotone"
                        class="text-primary fs-20"
                      ></iconify-icon>
                      Address Settings
                    </h4>
                  </div>

                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <form>
                          <div class="mb-3">
                            <label for="store-name" class="form-label">
                              City
                            </label>
                            <input
                              type="text"
                              id="store-name"
                              class={`form-control ${
                                errorsAddress.city ? 'is-invalid' : ''
                              }`}
                              placeholder="Enter City"
                              name="city"
                              value={profile?.city || valuesAddress?.city || ''}
                              onChange={handleChangeAddress}
                            />
                          </div>
                        </form>
                      </div>
                      <div class="col-lg-6">
                        <form>
                          <div class="mb-3">
                            <label for="owner-name" class="form-label">
                              Country
                            </label>
                            <input
                              type="text"
                              id="owner-name"
                              class={`form-control ${
                                errorsAddress.country ? 'is-invalid' : ''
                              }`}
                              placeholder="Enter Country"
                              name="country"
                              value={
                                profile?.country || valuesAddress?.country || ''
                              }
                              onChange={handleChangeAddress}
                            />
                          </div>
                        </form>
                      </div>
                      <div class="col-lg-6">
                        <div class="mb-3">
                          <label for="schedule-number" class="form-label">
                            Address
                          </label>
                          <input
                            type="text"
                            id="schedule-number"
                            name="address"
                            class={`form-control ${
                              errorsAddress.address ? 'is-invalid' : ''
                            }`}
                            placeholder="Enter Address"
                            value={
                              profile?.address || valuesAddress?.address || ''
                            }
                            onChange={handleChangeAddress}
                          />
                        </div>
                      </div>
                    </div>

                    <div class="text-end">
                      <a class="btn btn-success" onClick={handleSubmitAddress}>
                        {editLoader ? (
                          <div class="form-group col-sm-9">
                            <InfinitySpin width="100" color="#FE6B30" />
                          </div>
                        ) : (
                          <>Update User Address</>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title d-flex align-items-center gap-1">
                      <iconify-icon
                        icon="solar:shop-2-bold-duotone"
                        class="text-primary fs-20"
                      ></iconify-icon>
                      Password Settings
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <form>
                          <div class="mb-3">
                            <label for="store-name" class="form-label">
                              Password
                            </label>
                            <input
                              type="password"
                              id="store-name"
                              class={`form-control ${
                                errorsPassword.password ? 'is-invalid' : ''
                              }`}
                              placeholder="Enter Password"
                              name="password"
                              value={valuesPassword?.password || ''}
                              onChange={handleChangePassword}
                            />
                          </div>
                        </form>
                      </div>
                      <div class="col-lg-6">
                        <form>
                          <div class="mb-3">
                            <label for="owner-name" class="form-label">
                              Comfirm Password
                            </label>
                            <input
                              type="password"
                              id="owner-name"
                              class={`form-control ${
                                errorsPassword.confirm_password
                                  ? 'is-invalid'
                                  : ''
                              }`}
                              placeholder="Enter Comfirm Password"
                              name="confirm_password"
                              value={valuesPassword?.confirm_password || ''}
                              onChange={handleChangePassword}
                            />
                          </div>
                        </form>
                      </div>

                      <div class="col-lg-6">
                        <form>
                          <div class="mb-3">
                            <label for="owner-name" class="form-label">
                              Old Password
                            </label>
                            <input
                              type="password"
                              id="owner-name"
                              class={`form-control ${
                                errorsPassword.oldPassword ? 'is-invalid' : ''
                              }`}
                              placeholder="Enter Old Password"
                              name="oldPassword"
                              value={valuesPassword?.oldPassword || ''}
                              onChange={handleChangePassword}
                            />
                          </div>
                        </form>
                      </div>
                    </div>

                    <div class="text-end">
                      <a class="btn btn-success" onClick={handleSubmitPassword}>
                        {editLoader ? (
                          <div class="form-group col-sm-9">
                            <InfinitySpin width="100" color="#FE6B30" />
                          </div>
                        ) : (
                          <>Update Password</>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
